
import ListContent from './page3/Content'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'


export default {
name: "person",
components: {
Scroller, LoadMore, ListContent
},
data() {
return {
data: [],
page: 0,
status: {
pullupStatus: 'default'
}
}
},
methods: {
pullup() {
this.$store.dispatch('getData', {
page: ++this.page,
scb: (result) => {
this.data = this.data.concat(result)
}
});
}
},
computed: {
list() {
this.$nextTick(() => {
this.status.pullupStatus = 'default'
this.$refs.scroller.reset()
})
return this.data
}
},
mounted() {
this.pullup();
},
}



// WEBPACK FOOTER //
// ./src/components/Person.vue